export const DEFAULT_RATING = 5;

export const FIELD_EVENT_DEBOUNCE_TIME = 100;

export const NO_DATA: string = "--";

export const MAX_FILE_SIZE_TO_UPLOAD = 5 * 1024 * 1024; // 5 MB
export const MAX_FILE_SIZE_TO_UPLOAD_STRING =
  Math.round(MAX_FILE_SIZE_TO_UPLOAD / (1024 * 1024)) + `MB`;

export enum GroupBy {
  CreatedAt = "CREATED_AT",
  UpdatedAt = "UPDATED_AT",
}
export const ALL_RESPONSES_ID = "All Responses";
export const DATE_TIME_FORMAT = "d/M/yy - h:mm aa";
